export function SET_RAW_MATERIAL(state, _id) {
  state.materialSelected = _id;
}
